import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@app/common/header/header.component';
import { FooterComponent } from '@app/common/footer/footer.component';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <app-header></app-header>
    <router-outlet class="main-container"></router-outlet>
    <app-footer></app-footer>
  `,
})
export class PublicLayoutComponent {}
